import * as types from './accreditationAim.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_ACCREDITATION_AIM,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_ACCREDITATION_AIM,
		payload,
	}),
	get: payload => ({
		type: types.GET_ACCREDITATION_AIM,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_ACCREDITATION_AIM,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_ACCREDITATION_AIM,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
